import {CredentialsType} from 'src/openapi/admin/models/CredentialsType';

import type {MsDynamicCredentials} from 'src/openapi/admin/models/MsDynamicCredentials';

type IsMsDynamicTestReady = (credentials: MsDynamicCredentials | null) => boolean;

export const isMsDynamicTestReady: IsMsDynamicTestReady = credentials => {
    if (!credentials) {
        return false;
    }

    if (credentials.credentialsType === CredentialsType.PASSWORD) {
        return !!credentials.passwordCredentials.login
            && (!!credentials.passwordCredentials.password || credentials.passwordCredentials.passwordNotEmpty)
            && !!credentials.url;
    } else {
        return !!credentials.crmUrl;
    }
};
